import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FeedService } from '../../../Model/Feeds/feed.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AssetService } from '../../../Model/AssetModule/asset.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-asset-transfer',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule],
  templateUrl: './asset-transfer.component.html',
  styleUrl: './asset-transfer.component.scss'
})
export class AssetTransferComponent {
  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private Asset: AssetService,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.LoadAssetMaster();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  LoadAssetMaster() {
    this.isDisabled = true;
    this.Asset.LoadAssetTransfer({ SelectType: 1, ESS_AssetAdditionId: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
